import React from 'react';
import '../Colors.css';

const Maximize = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='Tram' d="M156.494 90.352h219.994c24.941 0 45.16-20.219 45.16-45.16v-0.036c0-24.937-20.219-45.156-45.16-45.156h-325.288c-28.275 0-51.2 22.925-51.2 51.2v325.291c0 24.941 20.219 45.16 45.16 45.16h0.036c24.941 0 45.16-20.219 45.16-45.16v-219.991l293.165 293.162c17.636 17.636 46.229 17.636 63.865 0l2.279-2.279c17.636-17.636 17.636-46.229 0-63.865l-293.173-293.165zM978.84 602.352h-0.036c-24.941 0-45.16 20.219-45.16 45.16v219.991l-293.165-293.169c-17.636-17.636-46.229-17.636-63.865 0l-2.279 2.279c-17.636 17.636-17.636 46.229 0 63.865l293.169 293.173h-219.994c-24.941 0-45.16 20.219-45.16 45.16v0.033c0 24.941 20.219 45.16 45.16 45.16h325.288c28.279 0 51.2-22.925 51.2-51.2v-325.288c0.004-24.944-20.216-45.164-45.156-45.164z"/>
    </svg>
  );
};

export default Maximize;